module.exports = __webpack_public_path__ + "static/media/cybercrime-large@3x.26d1fe5a.png";